import { createSlice } from '@reduxjs/toolkit'

import { Payload, ReduxRootState } from '../../../../types'

export type editorType = 'OnlyOffice' | 'Office365' | null

interface State {
  editor: editorType
  isEditorTypeLoading: boolean
}

const initialState: State = {
  editor: null,
  isEditorTypeLoading: false,
}

const editorSlice = createSlice({
  name: 'editor',
  initialState: initialState,
  reducers: {
    setEditorType: (state, { payload }: Payload<editorType>) => {
      state.editor = payload
    },
    setEditorTypeLoading: (state, { payload }: Payload<boolean>) => {
      state.isEditorTypeLoading = payload
    },
  },
})

export const { setEditorType, setEditorTypeLoading } = editorSlice.actions
export const editorReducer = editorSlice.reducer
export const editorTypeSelector = {
  getEditorType: (state: ReduxRootState) => state.editor.editor,
  isEditorTypeLoading: (state: ReduxRootState) =>
    state.editor.isEditorTypeLoading,
}
